export default {
  drawerTitle: {
    id: 'bo_sellers-orders-drawers-send_customer_receipt_drawer-drawer_title',
    defaultMessage: 'Send receipt to customer',
  },
  uploadReceiptForOrder: {
    id: 'bo_sellers-orders-drawers-send_customer_receipt_drawer-upload_receipt_for_order',
    defaultMessage: 'Upload receipt for this order.',
  },
  uploadReceipt: {
    id: 'bo_sellers-orders-drawers-send_customer_receipt_drawer-upload_receipt',
    defaultMessage: 'Upload receipt',
  },
  cancel: {
    id: 'bo_sellers-orders-drawers-send_customer_receipt_drawer-cancel',
    defaultMessage: 'Cancel',
  },
  successTitle: {
    id: 'bo_sellers-orders-drawers-send_customer_receipt_drawer-success_title_message',
    defaultMessage: 'Receipt uploaded ✔️',
  },
  successContent: {
    id: 'bo_sellers-orders-drawers-send_customer_receipt_drawer-success_content_message',
    defaultMessage: 'Your customer thanks you',
  },
} as const
